exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu-item .nav-link{\n  color:inherit\n}\n.menu-item .disabled-item span{\n  color:#e2e2e2\n}\n.h-nav-menu-dd{\n  background-color:#fff\n}\n.theme-dark .h-nav-menu-dd{\n  background-color:#262c49;\n  -webkit-box-shadow:0px 0px 30px #0f163a !important;\n          box-shadow:0px 0px 30px #0f163a !important\n}", ""]);

// exports
